var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer_copyright"},[_c('p',[_vm._v("Сеть магазинов «СУШИСЕТ» ©2013-"+_vm._s(_vm.$moment().format('YYYY')))]),_vm._v(" "),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v("\n    Приготовлено в\n    "),_c('a',{staticClass:"seonity",attrs:{"href":"https://seonity.ru","target":"_blank","rel":"nofollow"}},[_vm._v("\n      SEO"),_c('strong',[_vm._v("NITY")])])])
}]

export { render, staticRenderFns }